import React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { useBexApi } from '@shared-ui/bex-api-context';
import useNavigationParams from '../../hooks/useNavigationParams';
import { RelationshipsDataFragment, useRelationshipsQuery } from '../../graphql/__generated__/types';
import NavigatorLink from './navigator-link';

const DocumentationNavigator = () => {
  const { hubId, documentId } = useNavigationParams();
  const { context } = useBexApi();

  const { data, loading, error } = useRelationshipsQuery({ variables: { context, hubId, documentId } });

  if (error || loading || !data) {
    return null;
  }

  const relationships = data.documentation.relationships as RelationshipsDataFragment;
  const { previous, next } = relationships;

  return (
    <UitkSpacing
      margin={{ blockend: 'six', blockstart: 'two' }}
      padding={{ blockstart: 'six' }}
      border={['blockstart']}
      className="width-full"
    >
      <UitkLayoutFlex justifyContent="space-between" space="four">
        <div data-stid="previous">
          <UitkLayoutFlexItem maxWidth="half_width" className="navigation-item">
            {previous && <NavigatorLink link={previous} alignment="left" />}
          </UitkLayoutFlexItem>
        </div>
        <div data-stid="next">
          <UitkLayoutFlexItem maxWidth="half_width" className="navigation-item next">
            {next && <NavigatorLink link={next} alignment="right" />}
          </UitkLayoutFlexItem>
        </div>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default DocumentationNavigator;
